// extracted by mini-css-extract-plugin
export default {"required":"RequiredIndicator_required__eGgEX","aria":"RequiredIndicator_aria__jjWW4"};